// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"a98fa7ff","648":"670b39b5","807":"9b23f59d","817":"cd4d8564","973":"670b39b5"}[chunkId] + ".chunk.css";
};